import AuthBannerImage from "../Assets/IMG/auth-images/banner.png";
import LogoFull from "../Assets/IMG/logo-full.svg";
import LogoM from "../Assets/IMG/logo-m.svg";

// BUNDLE IMAGES

// SINGLE SERVICE IMAGES
import AppleMusicImage from "../Assets/IMG/services/singles/apple_music.png";
import DuolingoImage from "../Assets/IMG/services/singles/duolingo.png";
import NetflixImage from "../Assets/IMG/services/singles/netflix.png";
import SpotifyImage from "../Assets/IMG/services/singles/spotify.png";
import YoutubeImage from "../Assets/IMG/services/singles/youtube.png";
import ShowmaxImage from "../Assets/IMG/services/singles/showmax.png";
import DeezerBlackImage from "../Assets/IMG/services/singles/deezer-black.png";
import DeezerWhiteImage from "../Assets/IMG/services/singles/deezer-white.png";
import CapCutBlackImage from "../Assets/IMG/services/singles/capcut-black.png";
import CapCutWhiteImage from "../Assets/IMG/services/singles/capcut-white.png";
import GoogleOneImage from "../Assets/IMG/services/singles/google_one.png";
import Microsoft365Image from "../Assets/IMG/services/singles/microsoft-365.png";
import iCloudAppleMusicImage from "../Assets/IMG/services/singles/iCloud-AppleMusic_Combo_Image.png";
import CrunchyrollImage from "../Assets/IMG/services/singles/crunchyroll.png";

import {
  AdminProfileRole,
  FilterPeriodsProps,
  iCloudStorageProps,
  PossiblePeriods,
  PossibleServices,
} from "./Types";

export const BrandImages = {
  YoutubeImage: YoutubeImage,
  DuolingoImage: YoutubeImage,
  SpotifyImage: SpotifyImage,
  NetflixImage: NetflixImage,
  AppleMusicImage: AppleMusicImage,
  ShowmaxImage: ShowmaxImage,
  CapCutBlackImage: CapCutBlackImage,
  CapCutWhiteImage: CapCutWhiteImage,
  GoogleOneImage: GoogleOneImage,
  Microsoft365Image: Microsoft365Image,
  iCloudAppleMusicImage: iCloudAppleMusicImage,
  CrunchyrollImage: CrunchyrollImage,

  retrieveImage: (service: PossibleServices, theme?: "dark" | "light") => {
    if (service === "Apple Music") {
      return AppleMusicImage;
    } else if (service === "Netflix") {
      return NetflixImage;
    } else if (service === "YouTube Premium") {
      return YoutubeImage;
    } else if (service === "Spotify Premium") {
      return SpotifyImage;
    } else if (service === "Duolingo Super") {
      return DuolingoImage;
    } else if (service === "Showmax") {
      return ShowmaxImage;
    } else if (service === "CapCut Pro") {
      return theme === "dark" ? CapCutWhiteImage : CapCutBlackImage;
    } else if (service === "Google One") {
      return GoogleOneImage;
    } else if (service === "Deezer Premium") {
      return theme === "dark" ? DeezerWhiteImage : DeezerBlackImage;
    } else if (service === "Microsoft 365") {
      return Microsoft365Image;
    } else if (service === "iCloud - Apple Music") {
      return iCloudAppleMusicImage;
    } else if (service === "Crunchyroll") {
      return CrunchyrollImage;
    }
  },
};
export const Colors = {
  BlackPrimary: "var(--black-primary)",
  GrayTertiary: "var(--gray-tertiary)",

  BluePrimary: "var(--blue-primary)",
  GreenPrimary: "var(--green-primary)",
  GreenSecondary: "var(--green-secondary)",
  GreenLight: "var(--green-light)",

  GrayPrimary: "var(--gray-primary)",
  GraySecondary: "var(--gray-secondary)",
  BlackSecondary: "var(--black-secondary)",
  White: "var(--white-primary)",
  WhiteBlueTransparent: "var(--white-blue-transparent)",
  RedPrimary: "var(--red-primary)",
  SpotifyGreen: "var(--spotify-green)",
  OrangeSecondary: "var(--orange-secondary)",
  OrangePrimary: "var(--orange-primary)",
};

export const PurchasePeriods: { value: PossiblePeriods }[] = [
  { value: "30 Days" },
  { value: "3 Months" },
  { value: "6 Months" },
  { value: "1 Year" },
];
export const MusicProviders = [
  { title: "Spotify Premium", image: BrandImages.SpotifyImage },
  { title: "Apple Music", image: BrandImages.AppleMusicImage },
];

export const minimumLengthForCouponCode = 8;

export const ServiceList: PossibleServices[] = [
  "Apple Music",
  "Netflix",
  "Spotify Premium",
  "YouTube Premium",
  "Duolingo Super",
  "Showmax",
  "CapCut Pro",
  "Google One",
  "Deezer Premium",
  "Microsoft 365",
  "iCloud - Apple Music",
  "Crunchyroll",
];

export const AdminRoles: AdminProfileRole[] = ["admin", "operations"];
export { AuthBannerImage, LogoFull, LogoM };

export const FilterPeriodsList: { value: FilterPeriodsProps; label: string }[] =
  [
    {
      value: "30 Days",
      label: "30 Days",
    },
    {
      value: "3 Months",
      label: "3 Months",
    },
    {
      value: "6 Months",
      label: "6 Months",
    },
    {
      value: "1 Year",
      label: "1 Year",
    },
    {
      value: "Lifetime",
      label: "All Time",
    },
  ];

export const ValidIDLength = 32;

export const ValidMinimumTransactionReferenceLength = 8;
export const ValidMinimumCouponCodeLength = 5;

export const HttpSuccessCodes: number[] = [200, 201];
export const PlansWithLoginInformation: Omit<
  PossibleServices,
  "Apple Music" | "Spotify Premium" | "YouTube Premium" | "Duolingo Super"
>[] = ["Netflix", "Showmax", "Crunchyroll"];

export const iCloudStorageList: iCloudStorageProps[] = [
  "10GB",
  "40GB",
  "400GB",
];
